<template>
  <div />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

import {
  surveyAPI,
} from '@/services';

export default {
  name: 'ModalSurveyAccordance',
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
      show_survey_commissions: (state) => state.app.show_survey_commissions,
    }),
  },
  created() {
    if (this.show_survey_commissions) {
      this.createModalSurveyAccordance();
    }
  },
  methods: {
    ...mapActions({
      setShowCommissionSurvey: 'app/SET_SHOW_SURVEY_COMMISSIONS',
    }),
    createModalSurveyAccordance() {
      const { toggle } = createPopup(process.env.VUE_APP_TYPEFORM_CORBAN_COMMISSION_LINK, {

        hidden: {
          user_id: this.user.id,
          name: this.user.name,
          email: this.user.email,
          promoter_id: this.user.promoter_id,
        },

        onSubmit: async ({ formId, responseId }) => { // NOSONAR: callback assíncrono intencional
          const params = {
            name: 'corban-commission',
            details: {
              responseId,
              formId,
            },
          };

          await surveyAPI
            .completeSurvey(params)
            .then(() => {
              this.setShowCommissionSurvey(false);
              toggle();
            })
            .catch(() => {
              // ...
            });
        },
      });

      toggle();
    },
  },
};
</script>
<style lang="scss" scoped>
#form,
#form div {
  min-height: 55vh;
}
</style>
